<template>
  <div class="header">
    <el-row>
      <el-col :xs="6" :sm="3" :md="3" :lg="3" :xl="3">
        <div class="grid-content go-home">
          <el-button type="primary" icon="el-icon-s-home" style="width: 100%" @click="goToHome" v-if="showHameBtn">首页</el-button>
        </div>
      </el-col>
      <el-col :xs="12" :sm="18" :md="18" :lg="18" :xl="18">
        <div class="grid-content ">
          <h1>游戏表单提交</h1>
        </div>
      </el-col>
      <el-col :xs="6" :sm="3" :md="3" :lg="3" :xl="3">
        <div class="grid-content bg-purple-light"></div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  props: {
    'showHameBtn': {type: Boolean, default: true}
  },
  methods: {
    goToHome() {
      this.$router.push('/');
    }
  }
}
</script>
<style scoped>
.header {
  background: #F56C6C;
}

.header h1 {
  text-align: center;
  line-height: 45px;
  color: #fff;
  font-size: 18px;
  border-bottom: 1px solid #ececec;
  margin: 0;
}

.grid-content {
  width: 100%;
  height: 10px;
}

.grid-content {
  min-height: 45px;
}

.go-home {
  border-radius: 4px;
  display: flex;
  justify-content: center;
}

</style>
